<!--tab封装  -->
<template>
  <div class="tab">
    <div
      v-for="(item, i) in $route.path == '/document' &&
      $route.query.title == '公众服务'
        ? tabItem.grouping2
        : tabItem.children"
      :key="i"
      class="tab-item"
      :style="`left:${item.left?item.left:i * mypx}px;z-index:${tabItem.children.length + 1 - i};`"
      :class="{
        'is-active': item.tag == activeName,
        'long': item.tag == '诚信检验检测承诺书'
      }"
      @click="handleClick(item)"
      @mouseover="handleMouseover(item)"
    >
      {{ item.tag }}
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: '',
  props: { methodsIncluding: { typeof: String, default: 'click' } },
  components: {},
  data() {
    return {
      activeName: '',
      mypx: 160
    }
  },
  computed: {
    ...mapState(['tabItem', 'menuArr'])
  },
  watch: {
    '$route.query.tag': {
      handler(val) {
        this.activeName = val
        this.$emit('getCurrentTab', val)
        this.$emit('getCurrentKey', this.$route.query.key)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 监听交互方式
    handleClick(item) {
      this.methodsIncluding == 'hover' ? null : this.handleFunc(item)
    },
    handleMouseover(item) {
      this.methodsIncluding == 'click' ? null : this.handleFunc(item)
    },

    handleFunc(item) {
      this.activeName = item.tag

      if (
        this.$route.path == '/institutional-overview' ||
        this.$route.path == '/office-hall'
      ) {
        this.$emit('getCurrentTab', item.tag)
      } else {
        let newQuery = { ...this.$route.query, ...item }
        this.$router.push({ path: this.$route.path, query: newQuery })
      }
    }
  },

  mounted() {
    if (window.innerWidth < 768) {
      this.mypx = 130
    }
  },
  created() {}
}
</script>

<style lang="scss" scope>
.tab {
  width: 100%;
  height: 50px;
  background: url(../../assets/images/tab_bg_2.webp) no-repeat;
  background-size: 100% 100%;
  position: relative;
  border-radius: 10px 10px 0 0;
  overflow: hidden;
  .tab-item {
    position: absolute;
    width: 200px;
    height: 50px;
    background: url(../../assets/images/tab_selected_6.png) no-repeat;
    background-size: 100% 113%;
    color: #1b6ad2;
    font-size: 24px;
    font-weight: bold;
    line-height: 50px;
    padding-left: 36px;
    cursor: pointer;
    border-radius: 10px 10px 0 0;
    overflow: hidden;
    transition: all 0.3s;
  }
  .is-active {
    color: #fff;
    background: url(../../assets/images/tab_selected_5.png) no-repeat;
    background-size: 100% 113%;
  }
  .long {
    width: 320px;
  }
}
</style>
